import * as React from 'react';
import {Field, formValueSelector, InjectedFormProps, reduxForm , submit } from 'redux-form';
import {IAuthState} from '../../../../services/auth/models';
import {IChannel, ICustomer, IProduct} from '../../../../data/api/models';
import {II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import {Button, Col, ControlLabel, Form, FormGroup, HelpBlock, Modal, Row} from 'react-bootstrap';
import NavigationBar from '../../components/NavigationBar';
import Login from '../../../CustomerArea/scenes/Login';
import {
  isEmail,
  isRequired,
} from '../../../../util/validators';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import FieldFormControl from '../../../../components/FieldFormControl';
import {isUndefined} from 'util';
import FaCheck from 'react-icons/fa/check';
import FaInfoCircle = require('react-icons/lib/fa/info-circle');
import ContactUsModal from '../../components/ContactUsModal';

interface IDeclarationFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
  };

  insured: ICustomer;
  email: string;
  emailConfirmation: string;
  declaration: string[];
  vehicleCount: number;
  declarationQuestion: string[];
}

interface IDeclarationFormStates {
  declines?: any;
  referrals?: any;
  errors?: any;
  notFocused: boolean;
}

class DeclarationForm extends React.Component<IDeclarationFormProps, IDeclarationFormStates> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    notFocused: false,
  };

  public componentWillMount() {
    const {dispatch, change, auth, renewal, quote} = this.props;
    dispatch(change('quotationTypes', 'Msamlin Direct'));

    if (auth.isAuthenticated) {
      dispatch(change('insured.email', auth.customer.email));
      dispatch(change('insured.emailConfirmation', auth.customer.email));
      dispatch(change('insured.title', auth.customer.title));
      dispatch(change('insured.firstName', auth.customer.firstName));
      dispatch(change('insured.lastName', auth.customer.lastName));
      dispatch(change('insured.dob', auth.customer.dob));
      dispatch(change('insured.companyName', auth.customer.companyName));
      dispatch(change('insured.metadata', auth.customer.metadata));
      dispatch(change('insured.address', auth.customer.address));
      dispatch(change('insured.phone1', auth.customer.phone1));
      // dispatch(change('personalCustomer', auth.customer.companyName ? false : true));
    }
  }

  public componentWillReceiveProps(nextProps) {
    const {dispatch, change, auth, actions} = this.props;

    if (auth.isAuthenticated !== nextProps.auth.isAuthenticated && nextProps.auth.isAuthenticated) {
      actions.quote.resetExistingCustomerCheck();
      dispatch(change('insured.id', nextProps.auth.customer.id));
      dispatch(change('insured.title', nextProps.auth.customer.title));
      dispatch(change('insured.firstName', nextProps.auth.customer.firstName));
      dispatch(change('insured.lastName', nextProps.auth.customer.lastName));
      dispatch(change('insured.dob', nextProps.auth.customer.dob));
      dispatch(change('insured.email', nextProps.auth.customer.email));
      dispatch(change('insured.emailConfirmation', nextProps.auth.customer.email));
      dispatch(change('insured.address', nextProps.auth.customer.address));
      dispatch(change('insured.metadata', nextProps.auth.customer.metadata));
      dispatch(change('insured.companyName', nextProps.auth.customer.companyName));
      dispatch(change('insured.phone1', nextProps.auth.customer.phone1));
      // dispatch(change('personalCustomer', nextProps.auth.customer.companyName ? false : true));
    }
  }

  private renderVehicleCounter() {
    const {dispatch} = this.props;

    return (
      <div className="sub-content-container">
        <div className="vehicle-row">
          <div className="vehicle">
            <img src={require('../../img/vehicle.svg')} alt="" />
            How many motorised horseboxes would you like to insure?
          </div>
          <Field
            dispatch={dispatch}
            name="vehicleCount"
            type="number"
            component={FieldFormControl}
            min="0"
          />
        </div>
      </div>
    );
  }

  // setTimeout(() => this.handleSubmit(), 400);

  private areEmailsSame() {
    const { insured } = this.props;

    if (isUndefined(insured)) {
      return true;
    }

    return (! insured.email || ! insured.emailConfirmation)
      || insured.email === insured.emailConfirmation;
  }

  private validateDeclaration() {
    const {declaration} = this.props;
    for (const key in declaration) {
      if (declaration[key] === 'false' && parseInt(key, 10) !== 12) {
       return false;
      }
    }
    return true;
  }

  private declarationAgreed = () => {
    const {declarationQuestion, dispatch, change } = this.props;

    if (isUndefined(declarationQuestion)) {
      return false;
    }
    if (declarationQuestion.length < 5) {
      return false;
    }
    for (const key in declarationQuestion) {
      if ((declarationQuestion[key] === '' || declarationQuestion[key] === 'false') && parseInt(key, 10) < 5) {
        dispatch(change('declaration[1]', 'false'));
        return false;
      }
    }
    dispatch(change('declaration[1]', 'true'));
    return true;
  }

  private hasVehicles() {
    const { vehicleCount } = this.props;
    return vehicleCount > 0;
  }

  private validateVehicleCount() {
    const { vehicleCount } = this.props;
    return vehicleCount === 0 || vehicleCount <= 10;
  }

  public render() {
    const {
      handleSubmit,
      auth,
      quote,
      declaration,
      channel,
      insured,
      renderDefinition,
      renewal,
    } = this.props;
    const isAuth = auth.isAuthenticated;

    const isValid = this.areEmailsSame() && this.validateDeclaration() && this.declarationAgreed() &&
      this.hasVehicles() && this.validateVehicleCount();

    return (
      <div>
        <Form horizontal={true}
              onSubmit={handleSubmit}
              autoComplete="off">
          <div className="steps-container">
            <div className="sub-content-container">
              <div className="welcome-header">Welcome to Miller’s online quote tool for Horsebox Insurance.</div>

              <p style={{ fontSize: '15px' }}>
                Thank you for your interest in insuring your horsebox vehicle(s)* through Miller Insurance Services LLP.
                <br /><br />
                We are proud to have teamed up with leading speciality insurer and reinsurer MSIG Europe to provide you
                with an online ‘quote & buy’ facility for your horsebox vehicle(s). We hope you find it to be quick,
                simple and hassle-free.
                <br /><br />
                Should you require any assistance using this facility then please don’t hesitate to <ContactUsModal
                channel={channel} text="contact us" /> directly
                on {channel.phone}.
                <br /><br />
                For Commercial Customers, you have a duty of disclosure when answering the questions contained within
                this form. You must disclose all information which is, or ought to be known to you and which are
                material to the risk. For Consumer Customers, you have must take reasonable care to provide complete,
                accurate and honest answers to the questions contained within this form and not to make a
                misrepresentation.  When completing this from, you should take care to ensure that the information
                provided is complete and accurate. Failure to comply with your Duty of Disclosure or Fair Presentation
                may result in cover being amended or cancelled or may negatively affect any subsequent claims.
                <br /><br />
                *Up to 10 vehicles. For anything above this, please <ContactUsModal
                channel={channel} text="contact us" />.
              </p>
            </div>
          </div>
        </Form>
      </div>
    );
  }

  private handleChecks = () => {
    this.setState({
      notFocused: true,
    });
    this.handleCheckExistingCustomer();
  }

  private handleCheckExistingCustomer = () => {
    const { email, emailConfirmation, actions, auth, quote } = this.props;
    if (email === '' || emailConfirmation === '') {
      return;
    }

    const isAuth = auth.isAuthenticated;
    const emailsDifferent = quote.existingCustomer.email !== '' && email !== quote.existingCustomer.email;
    if (email === emailConfirmation && !isAuth && (!quote.existingCustomer.checked || emailsDifferent)) {
      actions.quote.checkExistingCustomer(email);
    }
  }

  private handleCloseModal = () => {
    const { actions } = this.props;
    actions.quote.closeExistingCustomerModal();
  }

  private handleSubmit = () => {
    const {quote, actions, dispatch} = this.props;

    if (quote.existingCustomer.checked && quote.existingCustomer.hasCustomer) {
      actions.quote.openExistingCustomerModal();
    } else {
      dispatch(submit('quote'));
    }
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const insured = selector(state, 'insured');
      const email = selector(state, 'insured.email');
      const emailConfirmation = selector(state, 'insured.emailConfirmation');
      const declaration = selector(state, 'declaration');
      const vehicleCount = selector(state, 'vehicleCount');
      const declarationQuestion = selector(state, 'declarationQuestion');

      return {
        startDate,
        quotationTypes,
        insured,
        email,
        emailConfirmation,
        declaration,
        vehicleCount,
        declarationQuestion,
        auth: state.auth,
        quote: state.quote,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
      },
    }),
  ),
])(DeclarationForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Declaration/index.tsx